module.exports = __webpack_public_path__ + "img/MZC.7ccc9562.svg";